module.exports = __webpack_public_path__ + "img/speaker-MatthewJanney.90a40a87.png";